$(document).ready(function(){
	
	//$('.hexaTeam').randomize('.hexaTeamMember');
	
	$('.hexaTeam .hexaTeamMember').each(function(){
		
		if(!$(this).hasClass('empty')) {
		
			$(this).removeClass('dark').removeClass('light');
			
			$rand = Math.floor(Math.random() * 3);
			
			if($rand == 1) $(this).addClass('light');
			if($rand == 2) $(this).addClass('dark');
		}
		
	});
	
	$('.hexaTeamMember:not(.empty)').on('mouseenter', function(){
		$('.info .name').text($(this).data('name'));
		$('.info .languages').text($(this).data('lang'));
		$('.info a').prop('href', $(this).data('li'));
		
		$left = $(this).offset().left-parseFloat($('.info').css('min-width'))+parseFloat($('.hexaTeam').css('margin-left'))-$('.hexaTeam').offset().left+30;
		
		$distanceToWindowEdge = $('.hexaTeam').offset().left;
		
		if($left < (-$distanceToWindowEdge+80)) $left = -$distanceToWindowEdge+100;
		
		$('.info').css({
			'left': 'auto',
			'left': $left+'px',				
			'top': $(this).offset().top-parseFloat($('.info .name').css('line-height'))-$('.hexaTeam').offset().top+'px'
		});
		
		$('.info').show();
	});
	
	$('.hexaTeamMember, .info').on('mouseout', function(){
		if ($('.info:hover').length == 0) {
			$('.info').hide();
		}
	});
	
	$('.hexaTeamMember, .info').on('mouseout', function(){
		if ($('.info:hover').length == 0) {
			$('.info').hide();
		}
	});
	
	
	// wenn ein leerer member container am ende ist dann add class half um nicht zu viel abstand nach unten zu erzeugen
	for (i = $('.hexaTeamMember').length - 1; i >= 0; i--) {
	  element = $('.hexaTeamMember')[i];
	  if($(element).hasClass('empty')) {
	  	$(element).addClass('half');
	  } else 
	  	break;
	}
	
	//$('.hexaTeam .hexaTeamMember').css('opacity', 1);
			
});

(function($) {

  $.fn.randomize = function(childElem) {
    return this.each(function() {
      var $this = $(this);
      var unsortedElems = $this.children(childElem);
      var elems = unsortedElems.clone();

      elems.sort(function() {
        return (Math.round(Math.random()) - 0.5);
      });

      for (var i = 0; i < elems.length; i++)
        unsortedElems.eq(i).replaceWith(elems[i]);
    });
  };

})(jQuery);